<form [formGroup]="form" (ngSubmit)="onSubmit()" class="enroll-card md:max-w-4xl mx-auto">
    <div class="enroll-page-header">
        <h1>Enrollment Application</h1>
        <p class="page-description">Please provide your information to begin the enrollment process</p>
    </div>

    <section class="enroll-section">
        <div class="enroll-section-header">
            <mat-icon class="enroll-section-icon">person</mat-icon>
            <span>Personal Information</span>
        </div>
        <div class="enroll-section-body">
            <div class="grid grid-cols-1 md:grid-cols-3 md:gap-3">
                <mat-form-field appearance="outline" class="w-full enroll-field">
                    <mat-label>First Name</mat-label>
                    <input matInput type="text" formControlName="firstName" maxlength="50" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full enroll-field">
                    <mat-label>Middle Name</mat-label>
                    <input matInput type="text" formControlName="middleName" maxlength="50"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full enroll-field">
                    <mat-label>Last Name</mat-label>
                    <input matInput type="text" formControlName="lastName" maxlength="50"/>
                </mat-form-field>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 md:gap-3">
                <mat-form-field appearance="outline" class="w-full enroll-field">
                    <mat-label>Date of Birth</mat-label>
                    <input matInput formControlName="dateOfBirth" [matDatepicker]="mainpicker" [max]="maxDate" [min]="minDate" dateMask placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matIconSuffix [for]="mainpicker"></mat-datepicker-toggle>
                    <mat-datepicker #mainpicker></mat-datepicker>
                </mat-form-field>
                <ng-container *ngIf="!isPayrollDeducted">
                    <mat-form-field appearance="outline" class="w-full enroll-field">
                        <mat-label>Personal Email</mat-label>
                        <input matInput type="email" formControlName="primaryEmail" maxlength="200"/>
                    </mat-form-field>
                </ng-container>
                <ng-container *ngIf="isPayrollDeducted">
                    <mat-form-field appearance="outline" class="w-full enroll-field">
                        <mat-label>Personal Email</mat-label>
                        <input matInput type="email" formControlName="secondaryEmail" maxlength="200"/>
                    </mat-form-field>
                </ng-container>
                <mat-form-field appearance="outline" class="w-full enroll-field">
                    <mat-label>Mobile Phone</mat-label>
                    <input matInput type="phone" formControlName="mobilePhone" mask="(000) 000-0000" />
                </mat-form-field>
            </div>

            <div *ngIf="!isPayrollDeducted && isNewHireEnrollment" class="grid grid-cols-1 md:grid-cols-3 md:gap-3">
                <mat-form-field appearance="outline" class="w-full md:max-w-xs enroll-field">
                    <mat-label>Hire Date</mat-label>
                    <input matInput formControlName="hireDate" [matDatepicker]="hireDatePickerDirect" [max]="maxDate" [min]="minDate" dateMask placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matIconSuffix [for]="hireDatePickerDirect"></mat-datepicker-toggle>
                    <mat-datepicker #hireDatePickerDirect></mat-datepicker>
                    <mat-hint>Required for new hire enrollment</mat-hint>
                </mat-form-field>
            </div>
        </div>
    </section>

    <section class="enroll-section" *ngIf="isPayrollDeducted">
        <div class="enroll-section-header">
            <mat-icon class="enroll-section-icon">work</mat-icon>
            <span>Employment</span>
        </div>
        <div class="enroll-section-body">
            <div class="grid grid-cols-1 md:grid-cols-3 md:gap-3">
                <mat-form-field appearance="outline" class="w-full enroll-field">
                    <mat-label>Work Email</mat-label>
                    <input matInput type="email" formControlName="primaryEmail" maxlength="200"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full enroll-field">
                    <mat-label>Employee ID</mat-label>
                    <input matInput type="text" formControlName="employeeId" maxlength="50"/>
                </mat-form-field>
                <mat-form-field *ngIf="isNewHireEnrollment" appearance="outline" class="w-full enroll-field">
                    <mat-label>Hire Date</mat-label>
                    <input matInput formControlName="hireDate" [matDatepicker]="hireDatePicker" [max]="maxDate" [min]="minDate" dateMask placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matIconSuffix [for]="hireDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #hireDatePicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </section>

    <section class="enroll-section">
        <div class="enroll-section-header">
            <mat-icon class="enroll-section-icon">home</mat-icon>
            <span>Home Address</span>
        </div>
        <div class="enroll-section-body">
            <fieldset formGroupName="homeAddress">
                <mat-form-field appearance="outline" class="w-full enroll-field">
                    <mat-label>Address</mat-label>
                    <input matInput type="text" formControlName="address" maxlength="200" />
                </mat-form-field>
                <div class="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-3">
                    <mat-form-field appearance="outline" class="w-full col-span-2 md:col-span-1 enroll-field">
                        <mat-label>City</mat-label>
                        <input matInput type="text" formControlName="city" maxlength="60" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-full enroll-field">
                        <mat-label>State</mat-label>
                        <input type="text" matInput formControlName="state" [matAutocomplete]="aStates" (input)="filterStates($event)" (focus)="onStateFocus($event)">
                        <mat-autocomplete requireSelection #aStates="matAutocomplete" [displayWith]="stateDisplay">
                            <mat-option *ngFor="let state of filteredStates | async" [value]="state.key">
                                {{state.key}} – {{ state.value }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-full enroll-field">
                        <mat-label>Zip Code</mat-label>
                        <input matInput type="text" formControlName="zipCode" mask="00000" />
                    </mat-form-field>
                </div>
            </fieldset>
        </div>
    </section>

    <section class="enroll-section">
        <div class="enroll-section-header">
            <mat-icon class="enroll-section-icon">family_restroom</mat-icon>
            <span>Dependents</span>
        </div>
        <div class="enroll-section-body">
            <div formArrayName="dependents">
                <p *ngIf="dependents.controls.length === 0" class="enroll-muted">No dependents added</p>
                <div *ngFor="let dep of dependents.controls; let i = index" [formGroupName]="i" class="enroll-dependent">
                    <div class="grid grid-cols-1 md:grid-cols-3 md:gap-3">
                        <mat-form-field appearance="outline" class="w-full enroll-field">
                            <mat-label>First Name</mat-label>
                            <input matInput type="text" formControlName="firstName" maxlength="50"/>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-full enroll-field">
                            <mat-label>Middle Name</mat-label>
                            <input matInput type="text" formControlName="middleName" maxlength="50"/>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-full enroll-field">
                            <mat-label>Last Name</mat-label>
                            <input matInput type="text" formControlName="lastName" maxlength="50"/>
                        </mat-form-field>
                    </div>
                    <div class="grid grid-cols-2 gap-3">
                        <mat-form-field appearance="outline" class="w-full enroll-field">
                            <mat-label>Date of Birth</mat-label>
                            <input matInput formControlName="dateOfBirth" [matDatepicker]="depenentpicker" [max]="maxDate" [min]="minDate" dateMask placeholder="MM/DD/YYYY" />
                            <mat-datepicker-toggle matIconSuffix [for]="depenentpicker"></mat-datepicker-toggle>
                            <mat-datepicker #depenentpicker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-full enroll-field">
                            <mat-label>Relationship</mat-label>
                            <mat-select formControlName="relationship">
                                <mat-option *ngFor="let relationship of relationships" [value]="relationship">
                                  {{ relationship | titlecase }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <button type="button" class="enroll-btn enroll-btn--secondary" (click)="removeDependent(i)">Remove</button>
                </div>
            </div>
            <button type="button" *ngIf="dependents.controls.length < 10" class="enroll-btn enroll-btn--secondary" (click)="addDependent()">Add Dependent</button>
        </div>
    </section>

    <section class="enroll-section">
        <div class="enroll-section-header">
            <mat-icon class="enroll-section-icon">card_membership</mat-icon>
            <span>Selected Plans</span>
        </div>
        <div class="enroll-section-body">
            <app-plans-summary
                [products]="products"
                [paymentFrequency]="defaultPaymentFrequency"
                [discountApplied]="discount">
            </app-plans-summary>
        </div>
    </section>

    <section class="enroll-section" *ngIf="isPayrollDeducted">
        <div class="enroll-section-header">
            <mat-icon class="enroll-section-icon">gavel</mat-icon>
            <span>Agreement</span>
        </div>
        <div class="enroll-section-body">
            <mat-checkbox formControlName="acceptTerms" class="terms-checkbox">
                <span class="text-sm text-gray-700">
                    By checking this box, I agree to the
                    <button type="button" (click)="toggleTerms()" class="text-[#1e3a5f] font-semibold hover:underline">
                        Membership Terms and Privacy Policy
                    </button>
                    and authorize enrollment with my employer.
                </span>
            </mat-checkbox>
            <div *ngIf="termsExpanded" class="mt-3 p-4 bg-gray-50 rounded-lg border border-gray-200 text-sm text-gray-700 leading-relaxed">
                <p class="mb-3">By enrolling, I agree to the membership terms applicable to my employer-sponsored plan. I understand coverage is subject to my employer's payroll deduction and plan documents.</p>
                <p>I acknowledge that Legal Resources is not a law firm, and that all legal services are provided by independent, participating attorneys.</p>
            </div>
            <div *ngIf="submitted && !form.get('acceptTerms')?.value" class="text-red-600 text-sm mt-2">
                You must accept the terms and conditions to continue
            </div>
            <div class="w-full mt-4">
                <p class="text-sm text-gray-500 mb-2">Please complete the security verification below.</p>
                <div id="turnstile-member-form"></div>
            </div>
        </div>
    </section>

    <div class="enroll-actions">
        <button type="submit" class="enroll-btn enroll-btn--primary">Continue</button>
    </div>
</form>
